module.exports = function getResource(label, vars = []) {
    const resources = {
        updatePaymentMethod: 'Mettre à jour le mode de paiement',
        remove: 'Supprimer',
        edit: 'Modifier',
        addNewCardTitle: 'Ajoutez une nouvelle carte de crédit ou de débit',
        cancel: 'Annuler',
        save: 'Enregistrer',
        cvc: 'CVV/CVC',
        updateSecurityCode: 'Veuillez saisir votre code de sécurité.',
        CVCDescription: 'Veuillez fournir le code CVV/CVC associé à votre carte pour mettre à jour votre abonnement.',
        gotIt: 'Got It',
        expiredCreditCardMsg: 'This card is expired. Please update your card information.'
    };

    return resources[label];
};
